import { IdentifierDTO } from '@zazume/zzm-base';
import { PriceVO } from '@zazume/zzm-utils';

import { I18NValues } from '#/lib/i18n/generatedKeys';

import { BureauReportRejection, ValidationErrors, RelatedModel } from './types';

interface Fields {
  relatedModel: RelatedModel;
  userId: IdentifierDTO;
  nonPaymentIds: IdentifierDTO[];
  error?: ValidationErrors;
  rejections?: BureauReportRejection[];
  incomeIds: IdentifierDTO[];
  totalAmount: PriceVO;
}

export class BureauReportOperation {
  relatedModel: RelatedModel;
  userId: IdentifierDTO;
  nonPaymentIds: IdentifierDTO[];
  error?: ValidationErrors;
  rejections?: BureauReportRejection[];
  incomeIds: IdentifierDTO[];
  totalAmount: PriceVO;

  constructor(params: Fields) {
    this.relatedModel = params.relatedModel;
    this.userId = params.userId;
    this.nonPaymentIds = params.nonPaymentIds;
    this.error = params.error;
    this.rejections = params.rejections;
    this.incomeIds = params.incomeIds;
    this.totalAmount = params.totalAmount;
  }

  static fromRaw(raw: any): BureauReportOperation {
    return new BureauReportOperation({
      ...raw,
      totalAmount: PriceVO.fromPrimitive(raw.totalAmount)
    });
  }

  getReadableError(): I18NValues | undefined {
    if (!this.error) {
      return undefined;
    }
    return `nonPayment.bureau.validationErrors.${this.error}`;
  }

  getReadableRejections(): { code: string; iTitle: I18NValues }[] | undefined {
    if (!this.rejections?.length) {
      return undefined;
    }

    return this.rejections.map(rejection => ({
      code: rejection.code,
      iTitle: `nonPayment.bureau.rejectionReasons.${rejection.scope}.${rejection.category}` as I18NValues
    }));
  }
}
